import { StoreApi } from 'zustand'
import { StoreState } from './useBotOnboardingStore'

export type IndexedFile = {
  name: string
  type: string
}

export type PollFilesState = {
  isIndexing: boolean
  indexedFiles: IndexedFile[]
  totalFileCount: number
  showTraining: boolean
}

export type PollFilesActions = {
  setIsIndexing: (isIndexing: boolean) => void
  setIndexedFiles: (indexedFiles: IndexedFile[]) => void
  setTotalFileCount: (totalFileCount: number) => void
}

export const createPollIndexingFileSlice = (
  set: StoreApi<StoreState>['setState']
): PollFilesState & PollFilesActions => ({
  isIndexing: false,
  indexedFiles: [],
  totalFileCount: 0,
  showTraining: true,
  setIsIndexing: (isIndexing: boolean) => {
    set({ isIndexing })
    if (!isIndexing) {
      setTimeout(() => {
        set({ showTraining: false })
      }, 5000)
    }
  },
  setIndexedFiles: (indexedFiles: IndexedFile[]) => set({ indexedFiles }),
  setTotalFileCount: (totalFileCount: number) => set({ totalFileCount }),
})
